import { SxProps } from '@mui/material';

import { FONT_ORACLE, TEXT_PRIMARY } from '../constants';

export const containerSx: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: { xs: 5, lg: 0 },
};

export const titleSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontWeight: 500,
  fontSize: { xs: 18, md: 24 },
  letterSpacing: { xs: '-0.36px', md: '-0.96px' },
  color: TEXT_PRIMARY,
};

export const subtitleSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontWeight: 400,
  fontSize: { xs: 15, md: 17 },
  letterSpacing: '-0.34px',
  color: '#181819',
  mt: 1,
  px: { xs: 5, lg: 0 },
};

export const seeAllSx: SxProps = {
  fontFamily: FONT_ORACLE,
  fontWeight: 500,
  fontSize: 14,
  color: TEXT_PRIMARY,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    opacity: 0.7,
  },
};
